import React from 'react';

import { observer } from 'mobx-react';
import i18next from 'i18next';
import noop from 'lodash/noop';
import { BringgFontIcons, BringgIcon } from '@bringg/bringg-icons';
import { BringgInput, Row, Col, Tooltip } from '@bringg/react-components';

import { useHasFeatureFlag } from 'bringg-web/utils/feature-flags';
import { Button } from '../../../components';
import { Translate } from '../../../translation';
import { useStores } from 'bringg-web/recipes';

interface Props {
	onAdd: () => void;
}

const ActionsConfigurationsHeader = observer(({ onAdd }: Props) => {
	const { actionsConfigurationsStore } = useStores();
	const editAllowed = useHasFeatureFlag('enabled_fixed_driver_actions_config');

	const setFilterText = (filterText: string) => {
		actionsConfigurationsStore?.setFilterText(filterText);
	};

	return (
		<Row className="actions-configurations-header" justify="space-between">
			<Col>
				<Tooltip
					title={
						editAllowed
							? ''
							: 'Sorry, this functionality is temporary disabled. Please contact your CSM for further support.'
					}
				>
					<span>
						<Button
							disabled={!editAllowed}
							className="add-actions-configuration"
							onClick={editAllowed ? onAdd : noop}
						>
							<Translate text="ACTION_CONFIGURATION.ADD" />
						</Button>
					</span>
				</Tooltip>
			</Col>

			<Col>
				<BringgInput
					className="action-search-input"
					placeholder={i18next.t('GLOBAL.SEARCH')}
					type="text"
					onChange={e => setFilterText(e.target.value)}
					value={actionsConfigurationsStore.filterText}
					prefix={<BringgIcon iconName={BringgFontIcons.Search} />}
				/>
			</Col>
		</Row>
	);
});

export default ActionsConfigurationsHeader;
